import name from './Name.vue';
import client from './Client.vue';
import Vue from 'vue';

export default {
    headings: {
        cls_column: '',
        name: Vue.prototype.trans('users.label.full_name'),
        client: Vue.prototype.trans('users.label.client'),
        actions: Vue.prototype.trans('vuetables.label.actions'),
    },

    texts: {
        count: Vue.prototype.trans('vuetables.label.countText'),
        filter: Vue.prototype.trans('vuetables.label.filter'),
        noResults: Vue.prototype.trans('vuetables.label.noResults'),
        loading: Vue.prototype.trans('vuetables.label.loading'),
        filterPlaceholder: Vue.prototype.trans('vuetables.label.search'),
    },

    sortable: ['name', 'client'],

    descOrderColumns: ['name', 'client'],

    filterable: [
        'full_name_reversed',
        'email',
        'username',
        'client_prefixed_name',
        'role_trans',
    ],

    templates: {
        name: name,
        client: client,
    },

    requestFunction(data) {
        if (this.$parent.$parent.showDeletedUsersOnly) {
            data.showDeletedUsersOnly = this.$parent.$parent.showDeletedUsersOnly;
        }

        if (this.$parent.$parent.onlyUsersWithoutUsergroup) {
            data.onlyUsersWithoutUsergroup = this.$parent.$parent.onlyUsersWithoutUsergroup;
        }

        if (this.$parent.$parent.onlyUsersWithoutCourseAssignment) {
            data.onlyUsersWithoutCourseAssignment = this.$parent.$parent.onlyUsersWithoutCourseAssignment;
        }

        if (this.$parent.$parent.filterByClient) {
            data.filterByClientId = this.$parent.$parent.filterByClient.id;
        }

        if (this.$parent.$parent.filterByRole) {
            data.filterByRoleId = this.$parent.$parent.filterByRole.value;
        }

        if (this.$parent.$parent.hideSubclientUsers) {
            data.hideSubclientUsers = this.$parent.$parent.hideSubclientUsers;
        }

        return axios
            .get(this.url, {
                params: data,
            })
            .catch(function(e) {
                this.dispatch('error', e);
            });
    },
};
